export default __webpack_public_path__ + "static/media/p_wdt_c_2.b065b671.mp3";